var homeCarousel2024 = (function () {

    const carouselExists = document.querySelector( '.splide' );

    function init() {
  
        if (carouselExists) {
            document.addEventListener( 'DOMContentLoaded', function() {
            var splide = new Splide( '.splide', {
                breakpoints: {
                    800: { arrows: false },
                  },
            } );
            splide.mount();

        } );
        }
      }

    init();
  
    return self;
  
}());
